import React from 'react'

const METHOD_CLASS = {
  GET: 'docs-method-get',
  POST: 'docs-method-post',
  PUT: 'docs-method-put',
  PATCH: 'docs-method-patch',
  DELETE: 'docs-method-delete'
}

/**
 * Colored HTTP-method badge + URL, as used in the ```endpoint fence (see Markdown.js).
 * Source format: "METHOD /path/to/resource".
 */
export function Endpoint({ source }) {
  const trimmed = (source || '').trim()
  const spaceIndex = trimmed.indexOf(' ')
  const method = (spaceIndex === -1 ? trimmed : trimmed.substring(0, spaceIndex)).toUpperCase()
  const path = spaceIndex === -1 ? '' : trimmed.substring(spaceIndex + 1).trim()
  const methodClass = METHOD_CLASS[method] || 'docs-method-default'

  return (
    <div className="docs-endpoint">
      <span className={'docs-method-badge ' + methodClass}>{method}</span>
      <code className="docs-endpoint-path">{path}</code>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/docs/api/Endpoint.js